/**
 * codeBlocks class for adding and managing copy buttons on code blocks
 */
export class CodeBlocks {
  constructor() {
    this.init();
  }

  /**
   * Initialize the manager
   */
  init() {
    const codeBlocks = document.querySelectorAll(".phiki");

    codeBlocks.forEach((codeBlock) => {
      // Create wrapper
      const wrapper = document.createElement("div");
      wrapper.className = "code-block-wrapper";

      // Wrap pre element
      codeBlock.parentNode.insertBefore(wrapper, codeBlock);
      wrapper.appendChild(codeBlock);

      // Add copy button
      const copyButton = this.createCopyButton();
      codeBlock.appendChild(copyButton);

      // Setup copy functionality
      this.initializeCopyButton(copyButton);
    });
  }

  /**
   * Create a copy button with icons
   * @returns {HTMLButtonElement}
   */
  createCopyButton() {
    const button = document.createElement("button");
    button.className = "copy-button";
    button.setAttribute("aria-label", "Copy to clipboard");

    // Copy icon
    const copyIcon = document.createElement("span");
    copyIcon.className = "copy-button__icon copy-button__icon--copy";
    copyIcon.innerHTML = this.getCopyIconSvg();

    // Check icon
    const checkIcon = document.createElement("span");
    checkIcon.className = "copy-button__icon copy-button__icon--check";
    checkIcon.innerHTML = this.getCheckIconSvg();

    button.appendChild(copyIcon);
    button.appendChild(checkIcon);

    return button;
  }

  /**
   * Initialize copy button functionality
   * @param {HTMLButtonElement} button
   */
  initializeCopyButton(button) {
    const code = button.closest(".phiki").querySelector("code").innerText;

    button.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(code);
        this.showFeedback(button);
      } catch (err) {
        console.error("Failed to copy code: ", err);
      }
    });
  }

  /**
   * Show copy feedback
   * @param {HTMLButtonElement} button
   */
  showFeedback(button) {
    button.classList.add("copied");
    button.inert = true;

    setTimeout(() => {
      button.classList.remove("copied");
      button.inert = false;
    }, 1000);
  }

  /**
   * Get copy icon SVG
   * @returns {string}
   */
  getCopyIconSvg() {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-1 -1 30 30" id="Copy-Paste--Streamline-Flex.svg"
  height="30" width="30">
  <g id="copy-paste--clipboard-copy-cut-paste">
    <path id="Subtract" stroke="currentColor" stroke-linecap="round"
      d="M8.8125 21.5938c-1.76372 -0.0256 -3.93576 -0.107 -5.7711 -0.2506 -0.9628 -0.0754 -1.72351 -0.8434 -1.79161 -1.8067 -0.333054 -4.71126 -0.333054 -9.18054 0 -13.8918 0.0681 -0.96332 0.82869 -1.7293 1.78759 -1.84412 0.2622 -0.03142 0.52582 -0.0637 0.7908 -0.09614 0.39444 -0.0483 0.79186 -0.09696 1.1921 -0.14364 0.13152 1.1417 0.9927 1.79938 2.43806 1.85382 0.39218 0.01476 0.70266 0.02726 0.95664 0.03748 0.57064 0.02296 0.85596 0.03444 1.14128 0.03444s0.57064 -0.01148 1.1413 -0.03444c0.25398 -0.01022 0.56446 -0.02272 0.95662 -0.03748 1.44534 -0.05444 2.30652 -0.7121 2.43806 -1.85376 0.40004 0.04666 0.7973 0.0953 1.19156 0.14358 0.26498 0.03244 0.5286 0.06472 0.79082 0.09614 0.95888 0.11482 1.71948 0.8808 1.78758 1.84412 0.03968 0.5614 0.09194 1.33122 0.12218 1.88654"
      stroke-width="2"></path>
    <path id="Union" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
      d="M11.65354 1.071928C13.228 1.13122 14.10928 1.906362 14.10928 3.24322c0 1.33686 -0.88128 2.112 -2.45574 2.17128 -2.54662 0.0959 -1.64924 0.0959 -4.19584 0 -1.57448 -0.05928 -2.45574 -0.83442 -2.45574 -2.17128 0 -1.336858 0.88126 -2.112 2.45574 -2.171292 2.5466 -0.095904 1.64922 -0.095904 4.19584 0Z"
      stroke-width="2"></path>
    <path id="Subtract_2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
      d="M15.55082 26.8438c1.45456 0.1024 2.84804 0.1562 4.58698 0.1562 1.7388 0 3.1324 -0.0538 4.587 -0.1562 1.1344 -0.08 2.0352 -0.9826 2.1082 -2.1176 0.2228 -3.4668 0.2228 -6.9514 0 -10.41836 -0.073 -1.13488 -0.9738 -2.03758 -2.1082 -2.11744 -1.4546 -0.1024 -2.8482 -0.15622 -4.587 -0.15622 -1.73894 0 -3.13242 0.05382 -4.58698 0.15622 -1.13442 0.07986 -2.03534 0.98258 -2.1083 2.11744 -0.22284 3.46696 -0.22284 6.95156 0 10.41836 0.07296 1.135 0.97388 2.0376 2.1083 2.1176Z"
      stroke-width="2"></path>
    <path id="Vector 145" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
      d="m22.1758 17.43212 -4.10856 0" stroke-width="2"></path>
    <path id="Vector 146" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
      d="m22.1758 22.0578 -4.10856 0" stroke-width="2"></path>
  </g>
</svg>`;
  }

  /**
   * Get check icon SVG
   * @returns {string}
   */
  getCheckIconSvg() {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-1 -1 30 30" id="Check-Square--Streamline-Flex.svg"
  height="30" width="30">
  <g id="check-square--check-form-validation-checkmark-success-add-addition-box-square-tick">
    <path id="Intersect" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
      d="M1.919734 20.537C2.228 23.4184 4.5454 25.7358 7.42532 26.0568 9.56442 26.2952 11.76074 26.5 14 26.5s4.43558 -0.2048 6.5746 -0.4432c2.88 -0.321 5.1974 -2.6384 5.5056 -5.5198 0.2276 -2.12696 0.4198 -4.3107 0.4198 -6.537 0 -2.22632 -0.1922 -4.41004 -0.4198 -6.53706 -0.3082 -2.8813 -2.6256 -5.19872 -5.5056 -5.519722C18.43558 1.704784 16.23926 1.5 14 1.5S9.56442 1.704784 7.42532 1.943218C4.5454 2.26422 2.228 4.58164 1.919734 7.46294 1.692166 9.58996 1.5 11.77368 1.5 14c0 2.2263 0.192168 4.41004 0.419734 6.537Z"
      stroke-width="2"></path>
    <path id="Vector" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
      d="M9 15.25 12.63636 19c1.71114 -4.91536 3.1362 -7.07228 6.36364 -10" stroke-width="2"></path>
  </g>
</svg>`;
  }
}

// Usage:
// new CodeBlockManager();
